import { defineComponent, createElementBlock, openBlock, createVNode, createElementVNode, unref, toDisplayString } from "vue";
import DarkModeToggle from "../DarkModeToggle.vue.js";
import _sfc_main$1 from "../../components/FlowIconButton.vue.js";
const _hoisted_1 = { class: "t-doc__header mobile-header" };
const _hoisted_2 = { class: "mobile-header-breadcrumbs" };
const _hoisted_3 = { class: "mobile-header-actions" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "DocumentMobileHeader",
  props: {
    label: {},
    showSideBar: { type: Boolean }
  },
  emits: ["showSearch", "toggleSidebar"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createVNode(unref(_sfc_main$1), {
          icon: _ctx.showSideBar ? "Close" : "Menu",
          label: _ctx.showSideBar ? "Close Menu" : "Open Menu",
          width: "20px",
          onClick: _cache[0] || (_cache[0] = () => emit("toggleSidebar"))
        }, null, 8, ["icon", "label"]),
        createElementVNode("span", _hoisted_2, toDisplayString(_ctx.label), 1),
        createElementVNode("div", _hoisted_3, [
          createVNode(unref(_sfc_main$1), {
            icon: "Search",
            label: "Search",
            variant: "clear",
            onClick: _cache[1] || (_cache[1] = () => emit("showSearch"))
          }),
          createVNode(DarkModeToggle, { class: "mobile-header-darkmode-toggle" })
        ])
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=DocumentMobileHeader.vue.js.map
